import { PageCard } from '@common/components/layout';
import { TableSkeleton } from '@common/components/skeleton/TableSkeleton';
import { useRouteBreadcrumb } from '@common/hooks';
import { AdminPage, Page } from '@hospital/components/layout';
import { LocationStoreContextWrapper } from '@hospital/contexts';
import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { useOutlet, useParams } from 'react-router-dom';
import { LocationDetailForm } from './LocationDetailForm';

/**
 * Edit Location View handles all rendering of editing a particular store/hospital location
 */
export const LocationDetailContainer = observer(() => {
    const { hospitalId } = useParams();
    const outlet = useOutlet();
    //get location store from parent context
    const store = useContext(LocationStoreContextWrapper.get());
    const breadcrumb = useRouteBreadcrumb();

    useEffect(() => {
        if (hospitalId)
            store.refreshHospital(parseInt(hospitalId));
    }, [store, hospitalId]);

    useEffect(() => {
        if (store.hospital)
            breadcrumb.setBreadCrumb(store.hospital.name);
    }, [breadcrumb, store.hospital])

    if (outlet !== null)
        return outlet;

    return (
        <AdminPage>
            <Page.Content>
                <Page.PageTitle text={store.hospital?.name} />
                {store.hospitalLoading &&
                    <PageCard>
                        <TableSkeleton rows={20} cols={3} ></TableSkeleton>
                    </PageCard>
                }
                {(!store.hospitalLoading && store.hospital !== undefined) &&
                    <LocationDetailForm
                        hospital={store.hospital}
                        pricingTierOrganization={store.hospitalPricingTierOrganization}
                        onUpdateHospital={h => store.updateHospital(h)}
                        hospitalHoursGroup={store.hospitalHoursGroup}
                        clearHospitalHoursConfirmation={store.clearHospitalHoursConfirmation}
                        setHospitalHoursChangesConfirmed={store.setHospitalHoursChangesConfirmed}
                        refreshIvlsDevices={id => store.refreshHospitalIvlsDevices(id)}
                        ivlsDevices={store.ivlsDevices}
                    />
                }
            </Page.Content>
        </AdminPage>
    );
});
